// @flow

import * as React from 'react';

import { type AuthZInfo } from '@ta/common.authz';
import { TabActiveContext } from '@ta/social.tabs';

import { RateDisclaimerProvider } from '@ta/social.offers';

import Feed from './SocialFeedSectionBuilder';

type Props = {
  userId: string,
  socialFeed: any,
  refetch: any => Promise<*>,
  error: any,
  fetchMore: any,
  locationId: number,
  member: any,
  mixerPlacement: string,
  puid: ?string,
  viewportCategory?: string,
  loggedInMemberAuthorization?: AuthZInfo,
};

const SocialActivityFeed = (props: Props) => {
  const updateFeed = (backwards: boolean, onFinish: ?(void) => void) =>
    props.fetchMore({
      variables: {
        reset: false,
        restoreFromFeedId: undefined,
        goBackwards: backwards,
      },
      updateQuery: (previousResult, { fetchMoreResult }) => {
        if (!fetchMoreResult) return previousResult;
        const fetchMoreSocialFeed = fetchMoreResult.socialFeed || fetchMoreResult.socialFeedV2;
        const previousResultSocialFeed = previousResult.socialFeed || previousResult.socialFeedV2;

        // If the feed is reset, replace the sections. Otherwise, concat new to end of old sections
        let sections;
        if (fetchMoreSocialFeed.feedWasReset) {
          ({ sections } = fetchMoreSocialFeed);
          // If the feed was reset we also want to scroll to the top
          // eslint-disable-next-line no-restricted-globals
          window.scrollTo(0, 0);
        } else if (backwards) {
          sections = [...fetchMoreSocialFeed.sections, ...previousResultSocialFeed.sections];
        } else {
          sections = [...previousResultSocialFeed.sections, ...fetchMoreSocialFeed.sections];
        }

        if (onFinish) {
          onFinish();
        }

        const newSocialFeed = {
          sections,
          reset: fetchMoreSocialFeed.feedWasReset,
          hasMore: fetchMoreSocialFeed.hasMore,
          hasPrevious: fetchMoreSocialFeed.hasPrevious,
          impressionId: fetchMoreSocialFeed.impressionId,
          __typename: previousResultSocialFeed.__typename,
        };

        if (previousResult.socialFeedV2) {
          return Object.assign({}, previousResult, {
            socialFeedV2: newSocialFeed,
          });
        }
        return Object.assign({}, previousResult, {
          socialFeed: newSocialFeed,
        });
      },
    });

  return (
    <TabActiveContext.Consumer>
      {tabData => (
        <RateDisclaimerProvider>
          <Feed
            {...props}
            updateFeed={updateFeed}
            reset={props.socialFeed && props.socialFeed.feedWasReset}
            socialFeed={props.socialFeed}
            refetch={props.refetch}
            error={props.error}
            locationId={props.locationId}
            isActive={tabData ? tabData.isActive : true}
          />
        </RateDisclaimerProvider>
      )}
    </TabActiveContext.Consumer>
  );
};

export default SocialActivityFeed;
